import React from 'react';

const TeamContainer = () => {
  return (
    <section className="pb-8 px-4 about-main-container">
      <div className="container mx-auto">
        <h2 className="text-white pb-8 text-33xl text-center">Our team</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 justify-items-center gap-2 auto-cols-auto mx-auto md:px-6">
          <div className="flex flex-col gap-2">
            <p className="w-full leading-6 text-white xl:leading-8 text-base">
              <span className="font-bold justify-self-stretch">
                Peter Ruppert
              </span>{' '}
              – 25 year veteran Music Consultant to Major Labels, Radio Stations
              and Artists. Peter started his career within a small Team at MTV
              in London the early 1990s.
            </p>
            <p className="w-full leading-6 text-white xl:leading-8 text-base">
              <span className="font-bold">Dirk Brockhausen, PhD</span> –
              Physicist, Developer, and Blockchain expert. Dirk spent some time
              working at Cern at the Large Hardron Collider and at IBM Zurich as
              an SAP consultant. Later he founded his own development and
              consulting company.
            </p>
            <p className="w-full leading-6 text-white xl:leading-8 text-base">
              <span className="font-bold">Jeff Golembo</span> – Experienced
              commercial and business affairs lawyer focusing on talent
              acquisition, rights and brand exploitation, global licensing and
              M&A activity in the recorded music and associated digital arenas.
              Wide industry knowledge both domestically and internationally
              having worked at Sony, Universal and MD at MCA Records.
            </p>
          </div>
          <div className="flex flex-col gap-2">
            <p className="w-full leading-6 text-white xl:leading-8 text-base">
              <span className="font-bold">Hugh Goldsmith</span> -Formerly MD of
              RCA before founding multi platinum record label, Innocent Records,
              in a JV with Virgin Records. 7 years later Hugh founded Brightside
              Recordings in a JV with SonyBMG. Hugh has been a recipient of the
              highly prestigious Music Week A&R Award and has enjoyed 20 UK
              Number 1’s in his career. Artists worked with include Take That,
              Annie Lennox, M People, Natalie Imbruglia, David Bowie, Dave
              Stewart, Stevie Wonder, Blue, Billie Piper, Atomic Kitten and
              Newton Faulkner.
            </p>
            <p className="w-full leading-6 text-white xl:leading-8 text-base">
              <span className="font-bold">
                High profile adviser/ambassador team,
              </span>{' '}
              comprised of Artists, Managers, Record label execs, art experts
              and professionals in the music artwork NFT/blockchain arena.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TeamContainer;
